<template>
  <div class="mobile-menu" :style="`top: ${promoBannerCorrect}px`">
    <div class="mobile-menu__wrapper">
      <div class="mobile-menu__catalog">
        <h1 @click.prevent="close">Каталог</h1>
        <ul class="mobile-menu__catalog-items">
          <li
            v-for="(item, index) in menuItems"
            :key="`${item?.name}-${index}`"
            class="mobile-menu__catalog-item"
          >
            <component
              :is="item.link ? 'a' : nuxtLinkComponent"
              :to="item.href"
              :href="item.href"
              :class="[{ has_icon: item.icon }, 'body-m-regular']"
              @click="$emit('hide')"
            >
              <span>{{ item?.name }}</span>
              <UiIcon v-if="item.icon" :name="item.icon" />
            </component>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits(['hide', 'toggleVisibleCatalog']);
const nuxtLinkComponent = shallowRef(defineNuxtLink({}));
const promoBannerCorrect = ref(52);
const menuItems = [
  {
    name: 'Промокоды',
    href: '/promokody/',
    icon: 'fire',
  },
  {
    name: 'Скидки дня',
    href: '/promo/sale/',
    icon: 'sale',
  },
  {
    name: 'Избранное',
    href: '/favorite/',
  },
  {
    name: 'Сравнение',
    href: '/compare/',
  },
  {
    name: 'Бренды',
    href: '/brands/',
  },
  {
    name: 'Магазины',
    href: '/magaziny/',
  },
  {
    name: 'Блог',
    href: 'https://price.ru/blog/',
    link: true,
  },
  {
    name: 'О нас',
    href: '/about/',
  },
  {
    name: 'Контакты',
    href: '/contacts/',
  },
  {
    name: 'Подключить магазин',
    href: 'https://biz.price.ru/welcome/',
    link: true,
  },
  {
    name: 'Разместить рекламу',
    href: 'https://biz.price.ru/welcome',
    link: true,
  },
  {
    name: 'Правила размещения',
    href: 'https://biz.price.ru/rules',
    link: true,
  },
];
const close = () => {
  const html = <HTMLElement>document.querySelector('html');
  html?.classList.remove('has-modal');
  emit('toggleVisibleCatalog', true);
};
onMounted(() => {
  if (document) {
    const promo = document.getElementById('promo-banner');
    if (promo) {
      promoBannerCorrect.value = 52 + promo.clientHeight;
    }
  }
});
</script>

<style lang="scss" scoped>
.mobile-menu {
  z-index: 90;
  position: fixed;
  left: 0;
  width: 100%;
  min-width: var(--promo, 0);
  height: calc((var(--fullvh, 100%)) - 102px - (var(--promobannerheight, 0px)));
  background: #fff;
  min-height: calc(
    (var(--fullvh, 100%)) - 102px - (var(--promobannerheight, 0px))
  );
  @include md-block {
    display: none;
  }

  &__wrapper {
    display: flex;
    align-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    overflow-y: auto;
  }

  &__catalog {
    padding: 16px;
    font-family: 'Inter', sans-serif;
    color: $achromatic-black;
    font-size: 14px;
    font-style: normal;
    line-height: 20px;
    width: 100%;

    h1 {
      font-weight: 700;
      margin-bottom: 12px;
    }

    ul {
      li {
        border-top: 1px solid $achromatic-card-bg;
        padding: 12px 0;
        font-weight: 500;

        a {
          display: flex;
          align-items: center;
          gap: 6px;
        }
      }
    }
  }

  &__bottom-menu {
  }
}
</style>
